import React from 'react';
import { FileQuestion, Check, X } from 'lucide-react';

const DraftRecoveryDialog = ({ draft, onRestore, onDiscard }) => {
  if (!draft) return null;

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return 'Unknown time';
    }
  };

  return (
    <div className="draft-dialog-overlay" data-testid="draft-recovery-dialog">
      <div className="draft-dialog">
        <div className="draft-dialog-header">
          <FileQuestion size={32} className="draft-icon" />
          <h3 className="draft-dialog-title">Resume Previous Entry?</h3>
          <p className="draft-dialog-subtitle">
            We found an unsaved draft from {formatDate(draft.timestamp)}
          </p>
        </div>
        
        <div className="draft-dialog-content">
          <p>Your session expired while you were working. Would you like to resume where you left off?</p>
        </div>

        <div className="draft-dialog-actions">
          <button 
            onClick={onRestore} 
            className="draft-btn draft-btn-primary"
            data-testid="restore-draft-btn"
          >
            <Check size={16} />
            Resume Draft
          </button>
          <button 
            onClick={onDiscard} 
            className="draft-btn draft-btn-secondary"
            data-testid="discard-draft-btn"
          >
            <X size={16} />
            Start Fresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default DraftRecoveryDialog;
